import React, { useState, useEffect } from "react";
import { membersgetApi } from "../registerApi";
// import { membersgetApi } from "../membersApis";
// import membersApi from "../membersApis";
// import register from "../registerApi";
// import { members } from "../membersApis";
import _ from "lodash";
import { AccountAvatarIcon, RefreshIcon } from "./icons";

// (@1b9Wl4Z0AkMc
// fanikiaf
export default function Members() {
  const [activeSection, setActiveSection] = useState("login");

  const [members, setMembers] = useState({
    data: [],
    loading: false,
    text: "Refresh",
  });
  useEffect(() => {
    if (activeSection === "members") {
      handleRefresh();
    }
    return () => {
      // console.log("This will be logged on unmount");
    };
  }, [activeSection]);
  // const []
  const [data, setData] = useState({
    email: "",
    password: "",
  });

  const [error, setError] = useState("");
  function handleChangeInput(label, value) {
    setData((data) => ({
      ...data,
      [label]: value,
    }));
  }
  function handleLogin(e) {
    e.preventDefault();
    let error = false;
    if (data.email !== "fanikiafrica40@gmail.com") {
      error = true;
    }
    if (data.password !== "2022$") {
      error = true;
    }
    if (error) {
      setError("Invalid email or password, try again!");
      return;
    }
    setActiveSection("members");
  }

  // console.log("mem", members);
  function handleLogout() {
    setActiveSection("login");
    setMembers({
      data: [],
      loading: false,
      text: "Refresh",
    });
  }
  // function handleRefresh(){
  const handleRefresh = async () => {
    setMembers((memb) => ({
      ...memb,
      loading: true,
      text: "Refreshing...",
    }));
    const response = await membersgetApi();
    // console.log("members", response);
    let dt = [];
    if (response.ok) {
      const respData = response.data.data;
      // console.log("data", respData);
      const mapped = respData.map((dt) => {
        const path = dt.profile;
        const splitted = path ? path.split("/") : null;
        const hobbies = dt.hobbies ? dt.hobbies.split(",") : [];
        return {
          //  image: null,
          ...dt,
          firstName: dt.firstName,
          lastName: dt.lastName,
          birthDay: `${dt.birthMonth} ${dt.birthDay}`,
          phone: dt.phoneNumber,
          industry: dt.industry,
          package: dt.package,
          hobbies: hobbies,
          email: dt.email,
          image: splitted
            ? `https://fanikiafrica.org/betterme/${splitted[0]}/storage/${splitted[1]}/${splitted[2]}`
            : null,
        };
      });
      // console.log("mapped", mapped);
      dt = _.orderBy(mapped, "firstName", "asc");
    }
    setMembers((memb) => ({
      ...memb,
      loading: false,
      data: dt,
      text: "Refresh",
    }));
  };
  // }
  return (
    <div>
      <div className="h-28">
        <div className="bg-white shadow-xl py-5 px-2 fixed top-0 left-0 w-full z-10">
          <div className="flex justify-between max-w-md mx-auto">
            <div>
              <h2 className="text-secondaryTheme text-xl font-semibold">
                Faniki Registered Members:{members.data.length}
              </h2>
              <button
                onClick={handleRefresh}
                className="flex items-center px-4 py-2 rounded-md bg-theme text-white"
              >
                <RefreshIcon />
                <span className="ml-2">{members.text}</span>
              </button>
            </div>

            <button
              onClick={handleLogout}
              className="px-3 py2 cursor-pointer hover:bg-gray-200 rounded-md"
            >
              Logout
            </button>
          </div>
        </div>
      </div>

      {activeSection === "members" ? (
        <div className="max-w-md mx-auto">
          {members.loading ? (
            <div className="flex flex-col">
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((item) => (
                <div className="mb-5" key={item}>
                  <MembersCardLoading />
                </div>
              ))}
            </div>
          ) : (
            <div className="flex flex-col">
              {members.data.map((item) => (
                <div className="mb-5" key={item.id}>
                  <MembersCard data={item} />
                </div>
              ))}
            </div>
          )}
        </div>
      ) : (
        <div className="max-w-md mx-auto">
          <LoginForm
            onLogin={handleLogin}
            onChangeInput={handleChangeInput}
            error={error}
            data={data}
          />
        </div>
      )}
    </div>
  );
}

function LoginForm({ data, onLogin, onChangeInput, error }) {
  return (
    <div className="bg-gray-50 flex flex-col justify-center items-center">
      <div className="bg-white border border-gray-300 w-80 py-8 flex items-center flex-col mb-3">
        <h1>Faniki Admin Login</h1>
        <form className="mt-8 w-64 flex flex-col" onSubmit={onLogin}>
          {error && <small className="text-red-400">{error}</small>}
          <input
            autofocus
            className="text-xs w-full mb-2 rounded border bg-gray-100 border-gray-300 px-2 py-2 focus:outline-none focus:border-gray-400 active:outline-none"
            id="email"
            placeholder="email"
            type="email"
            value={data.email}
            onChange={(e) => onChangeInput("email", e.target.value)}
          />
          <input
            autofocus
            className="text-xs w-full mb-4 rounded border bg-gray-100 border-gray-300 px-2 py-2 focus:outline-none focus:border-gray-400 active:outline-none"
            id="password"
            placeholder="Password"
            type="password"
            value={data.password}
            onChange={(e) => onChangeInput("password", e.target.value)}
          />

          <button
            onClick={onLogin}
            className=" text-sm text-center bg-blue-400 text-white py-1 rounded font-medium"
          >
            Log In
          </button>
        </form>
      </div>
    </div>
  );
}

function MembersCard({ data }) {
  // const data = {
  //   image: null,
  //   firstName: "Eric",
  //   lastName: "Ribia",
  //   birthDay: "November 25",
  //   phone: "+25475638973",
  //   industry: "Information Technology",
  //   package: "Standard",
  //   hobbies: ["cooking", "feeding"],
  //   email: "eric.ndungu16@gmail.com",
  // };
  return (
    <div className="bg-white border-2 border-gray-300 p-6 rounded-md tracking-wide shadow-lg">
      <div
        id="header"
        className="flex items-start mb-4 flex-col sm:flex-row justify-center sm:items-center"
      >
        <div className="mx-auto w-28 h-28 border rounded-full relative bg-gray-100 mb-4 shadow-inset overflow-hidden">
          {data.image ? (
            <div
              className="bg"
              style={{
                backgroundImage: `url('${data.image}')`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                width: "auto",
                height: "100%",
              }}
            ></div>
          ) : (
            <AccountAvatarIcon iconClasses="h-28 w-28 text-gray-300 rounded-full" />
          )}
        </div>
        <div
          id="header-text"
          className="leading-5 sm:ml-6 ml-0 sm text-center sm:text-left"
        >
          <h4
            id="name"
            className="text-xl font-semibold flex items-center justify-center sm:justify-start"
          >
            <span>
              {data.firstName} {data.lastName}
            </span>
          </h4>
          <div className="mb-3">
            {data.birthDay ? (
              <span className="text-sm italic">
                🎂 <span className="italic">{data.birthDay}</span>
              </span>
            ) : (
              <span className="text-sm  flex items-center">
                😓
                <span className="italic mr-2">No birthday added</span>
              </span>
            )}
          </div>
          <div className="flex flex-col">
            <h5 id="job" className="font-semibold text-gray-400">
              {data.email}
            </h5>
            <a
              className="font-semibold text-blue-300 hover:underline"
              href={`tel:${data.phone}`}
            >
              Phone: {data.phone}
            </a>
          </div>
        </div>
      </div>
      <div id="quote">
        <div className="flex items-center mb-5">
          <p>Industry:</p>
          <p>{data.industry}</p>
        </div>
        <div className="flex items-center mb-5">
          <p>Package:</p>
          <p>{data.package}</p>
        </div>
        <div className="flex items-center mb-5">
          <p>Hobbies:</p>
          <p className="italic text-gray-600">
            {data.hobbies.join(",").toString()}
          </p>
        </div>
      </div>
    </div>
  );
}
function MembersCardLoading() {
  return (
    <div className="border border-blue-300 shadow rounded-md p-4 max-w-sm w-full mx-auto">
      <div className="animate-pulse flex space-x-4">
        <div className="rounded-full bg-gray-300 h-10 w-10"></div>
        <div className="flex-1 space-y-6 py-1">
          <div className="h-2 bg-gray-300 rounded"></div>
          <div className="space-y-3">
            <div className="grid grid-cols-3 gap-4">
              <div className="h-2 bg-gray-300 rounded col-span-2"></div>
              <div className="h-2 bg-gray-300 rounded col-span-1"></div>
            </div>
            <div className="h-2 bg-gray-300 rounded"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
